export function convertLowerCamelToSnake(value: string): string {
    return value.replace(/[A-Z][a-z]*/g, (match) => `_${match.toLowerCase()}`);
}

export function convertSnakeToLowerCamel(value: string): string {
    return value.replace(/_[A-Za-z]{1}/g, (match) => match[1].toUpperCase());
}
